"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = void 0;

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _object = require("../utils/object");

var _errors = require("../constants/errors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateActionType = function validateActionType(type) {
  if ((0, _isNull.default)(type)) {
    throw new Error(_errors.ACTION_TYPE_NULL);
  } else if ((0, _isUndefined.default)(type)) {
    throw new Error(_errors.ACTION_TYPE_UNDEFINED);
  }
};

var validateMetaOrPayload = function validateMetaOrPayload(obj, msg) {
  if (!(0, _object.isObjectOrNothing)(obj) || (0, _isArray.default)(obj)) {
    throw new Error(msg);
  }
};
/**
 * The function createAction() - generates and validate actions. Actions are SFA
 * compliant.
 *
 * <h4>FSA</h4>
 * <p>FSA is Flux Standard Action, which a human-friendly standard for Flux action
 * objects. It's much easier to work with Flux actions if we can make certain
 * assumptions about their shape. FSA action is plain javascript object which
 * contains these properties:</p>
 * <ol>
 *   <li><em>type</em> - type is not optional, has to be defined, it is a string type.</li>
 *   <li><em>payload</em> - a plain javascript object with additional data we want to pass</li>
 * to reducers
 *   <li><em>meta</em> - meta information about different</li>
 * </ol>
 *
 *
 * @exports createAction
 * @name skybase-core.base#createAction
 *
 * @method
 * @param  {String} type - The action ID
 * @param  {Object} payload - payload object
 * @param  {Object} meta - meta object
 * @return {Action} will return the locale action object
 */


var createAction = function createAction(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = arguments.length > 2 ? arguments[2] : undefined;
  validateActionType(type);
  validateMetaOrPayload(payload, (0, _errors.ACTION_PAYLOAD_INVALID)(type));
  validateMetaOrPayload(meta, (0, _errors.ACTION_META_INVALID)(type));
  return (0, _pickBy.default)({
    type: type,
    payload: payload,
    meta: meta
  }, function (key) {
    return !(0, _isUndefined.default)(key);
  });
};

exports.createAction = createAction;
//# sourceMappingURL=create-action.js.map